import React, { useContext, useState } from "react";
import "./BookRide.css";
import map from "../../assets/imgs/map.png";
import car from "../../assets/imgs/car.png";
import bike from "../../assets/imgs/bike.png";
import bus from "../../assets/imgs/bus.png";
import train from "../../assets/imgs/train.png";
import picon from "../../assets/imgs/picon.png";
import { UserContext } from "../../App";

const BookRide = () => {
  const [whichVehicle] = useContext(UserContext);
  const [area, setArea] = useState({});
  const [searchBtn, setSearchBtn] = useState({});
  const handleOnBlur = (e) => {
    const newArea = { ...area };
    newArea[e.target.name] = e.target.value;
    setArea(newArea);
  };
  const handleSearch = (e) => {
    const newSearchBtn = { ...searchBtn };
    newSearchBtn.isClicked = true;
    setSearchBtn(newSearchBtn);
    e.preventDefault();
  };
  return (
    <div className="book-ride-div">
      <div className="pick-area">
        {!searchBtn.isClicked && (
          <form action="#" className="search-form">
            <h5>Pick From</h5>
            <input
              type="text"
              className="book-ride-form-input"
              name="pickFrom"
              onBlur={handleOnBlur}
            />
            <h5>Pick To</h5>
            <input
              type="text"
              className="book-ride-form-input"
              name="pickTo"
              onBlur={handleOnBlur}
            />
            <h5>Select Date</h5>
            <input type="date" name="date" className="book-ride-form-input" />
            <input
              type="submit"
              value="Search"
              className="book-ride-form-input book-ride-submit-input"
              onClick={handleSearch}
            />
          </form>
        )}
        {searchBtn.isClicked && (
          <div>
            <div className="selected-location-div">
              <h4>
                {area.pickFrom} ------&gt; {area.pickTo}
              </h4>
            </div>
            <div className="vehicle-div">
              <div className="vehicle-img-div1">
                {whichVehicle.vehicle === "bike" ? (
                  <img src={bike} alt="" />
                ) : whichVehicle.vehicle === "car" ? (
                  <img src={car} alt="" />
                ) : whichVehicle.vehicle === "bus" ? (
                  <img src={bus} alt="" />
                ) : (
                  <img src={train} alt="" />
                )}
              </div>
              <div className="vehicle-img-div2">
                <img src={picon} alt="" />
              </div>
              <p>2</p>
              <p style={{ marginLeft: 100 }}>$100</p>
            </div>
            <div className="vehicle-div">
              <div className="vehicle-img-div1">
                {whichVehicle.vehicle === "bike" ? (
                  <img src={bike} alt="" />
                ) : whichVehicle.vehicle === "car" ? (
                  <img src={car} alt="" />
                ) : whichVehicle.vehicle === "bus" ? (
                  <img src={bus} alt="" />
                ) : (
                  <img src={train} alt="" />
                )}
              </div>
              <div className="vehicle-img-div2">
                <img src={picon} alt="" />
              </div>
              <p>4</p>
              <p style={{ marginLeft: 100 }}>$60</p>
            </div>
            <div className="vehicle-div">
              <div className="vehicle-img-div1">
                {whichVehicle.vehicle === "bike" ? (
                  <img src={bike} alt="" />
                ) : whichVehicle.vehicle === "car" ? (
                  <img src={car} alt="" />
                ) : whichVehicle.vehicle === "bus" ? (
                  <img src={bus} alt="" />
                ) : (
                  <img src={train} alt="" />
                )}
              </div>
              <div className="vehicle-img-div2">
                <img src={picon} alt="" />
              </div>
              <p>5</p>
              <p style={{ marginLeft: 100 }}>$50</p>
            </div>
          </div>
        )}
      </div>
      <div className="view-location">
        <img src={map} alt="" />
      </div>
    </div>
  );
};

export default BookRide;
